<div class="container">
    <p>It seems the resource you are trying to get does not exist.</p>
    <img src="assets/images/error.gif" alt="error"/>
</div>
